import "./contact.css"
import { Form, Input, Button, message, Image } from 'antd';
import { useState } from "react";
import { debounce } from "lodash";
const { TextArea } = Input;
function Contact(){
    // 定义输入框
    let [name,setName] = useState()
    let [email,setEmail] = useState()
    let [subject,setSubject] = useState()
    let [messages,setMessages] = useState()
    // 定义输入框状态
    let [nameStatus,setNameStatus] = useState()
    let [emailStatus,setEmailStatus] = useState()
    let [subjectStatus,setSubjectStatus] = useState()
    let [messagesStatus,setMessagesStatus] = useState()

    // 防抖内容
    async function submitMessage(){
        // console.log(111)
        // return 
        // e.preventDefault();
        if(!name){
            setNameStatus('error')
            message.error('name is empty')
            return
        }else{
            setNameStatus(null)
        }
        if(!email){
            setEmailStatus('error')
            message.error('email is empty')
            return
        }else{
            const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;  
            if(!regex.test(email)){
                setEmailStatus('error')
                message.error('email is error')
                return
            }else{
                setEmailStatus(null)
            }
        }
        setNameStatus(null)
        setEmailStatus(null)
        setSubjectStatus(null)
        setMessagesStatus(null)
        // console.log(name,email,subject,messages) // 准备提交的数据
        
        const formData = new FormData()
        formData.append('name',name)
        formData.append('email',email)
        formData.append('subject',subject)
        formData.append('messages',messages)
        try{
            const res = await fetch( 
                'https://formspree.io/f/meoaqkay',
                {
                    method:'POST',
                    body:formData,
                    headers:{
                        'Accept': 'application/json'
                    }
                }
            )
            if(res.ok || res.status === 200){
                message.success('You have successfully submitted, thank you!')
                setName('')
                setEmail('')
                setSubject('')
                setMessages('')
            }else{
                message.error('Sorry, your submission has failed...')
            }
        }catch(err){
            console.error(err)
        }
    }
    // 设计防抖
    const debounceSubmit = debounce(submitMessage,3000)
    // 提交事件
    const submitdebounce = ()=>{
        debounceSubmit()
    }

    // 两个二维码
    const qrCode1code = require('../../../assets/images/qrCode/wechat-code.png')
    const qrCode2code = require('../../../assets/images/qrCode/WhatsApp-code.png')


    return <div className="contact" id="contact-4">
        <div className="title">CONTACT US</div>
        <div className="fonts">
            Inquiries 
        </div>
        <div className="fonts">
            For any inquiries, questions or commendations, please fill out the following form. 
        </div>

        <div className="forms">
            <Form name="customerForm" style={{ width:'100%' }} autoComplete="off">
                <Form.Item>
                    <Input status={ nameStatus } value={ name } onChange={ e => setName(e.target.value) } placeholder="Name*" className="form-item"></Input>
                </Form.Item>
                <Form.Item>
                    <Input status={ emailStatus } value={ email } onChange={ e => setEmail(e.target.value) } placeholder="Email*" className="form-item"></Input>
                </Form.Item>
                <Form.Item>
                    <Input status={ subjectStatus } value={ subject } onChange={ e => setSubject(e.target.value) } placeholder="Subject" className="form-item"></Input>
                </Form.Item>
                <Form.Item>
                    <TextArea 
                        status={ messagesStatus }
                        showCount
                        maxLength={150}
                        placeholder="Message"
                        style={{ height: 120, resize: 'none' }}
                        value={ messages } onChange={ e => setMessages(e.target.value) }
                    />
                </Form.Item>
                <Form.Item>
                    <Button onClick={ submitdebounce } style={{ marginTop:'10px' }} type="primary">Send</Button>
                </Form.Item>
            </Form>
        </div>
        
        <div className="fonts">
            Email: judy@joyfashion-clothing.com 
        </div>
        <div className="fonts">
            Guangzhou Office (Show Room)
        </div>
        <div className="fonts">
            Room 103,Building A1, Pazhou Hezi Industrial Park, No.2842 XinGangDong
        </div>
        <div className="fonts">
            Road,Haizhu District,Guangzhou, China. Post code: 510335
        </div>
        <div className="fonts" style={{ marginTop:'30px' }}>
            Easy Contact via Wechat and Whatsapp, pls scan the following:
        </div>
        <div className="show-code">
            <div className="code"><Image draggable={ false } preview={ false }  src={ qrCode1code }></Image></div>
            <div className="code"><Image draggable={ false } preview={ false }  src={ qrCode2code }></Image></div>
        </div>
    </div>
}
export default Contact;